import { useTranslation } from 'react-i18next';
import { CardHeader } from '@/components/base/Card';
import { upcomingSessions } from '@/mocks/dashboard';

export default function UpcomingSessions() {
  const { t } = useTranslation();

  return (
    <div className="bg-background-50 rounded-xl border border-background-200 p-5 h-full">
      <CardHeader
        title={t('dashboard.todaysSchedule')}
        subtitle={t('dashboard.sessionsCount', { count: upcomingSessions.length })}
        icon="ri-calendar-2-line"
        iconBg="bg-primary-100"
      />

      <div className="space-y-3">
        {upcomingSessions.map((s) => (
          <div
            key={s.id}
            className="flex items-start gap-3 p-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer group"
          >
            {/* Time block */}
            <div className="flex-shrink-0 w-14 pt-0.5">
              <span className="text-xs font-label font-700 text-foreground-800 block leading-tight">
                {s.time.includes('Tomorrow') ? t('common.tomorrow') : t('common.today')}
              </span>
              <span className="text-xs text-foreground-500 font-label">
                {s.time.replace('Today, ', '').replace('Tomorrow, ', '')}
              </span>
            </div>

            {/* Connector dot */}
            <div className="flex-shrink-0 flex flex-col items-center pt-1">
              <div className={`w-2 h-2 rounded-full ${s.status === 'upcoming' ? 'bg-primary-500' : 'bg-foreground-300'}`} />
              {s.id !== upcomingSessions[upcomingSessions.length - 1].id && (
                <div className="w-0.5 flex-1 min-h-[16px] bg-background-300 mt-1" />
              )}
            </div>

            {/* Details */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-0.5">
                <div className={`w-6 h-6 flex items-center justify-center rounded-full ${s.avatarBg} text-background-50 text-[10px] font-700 font-label flex-shrink-0`}>
                  {s.avatar}
                </div>
                <span className="text-sm font-label font-medium text-foreground-800 truncate">{s.student}</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-500 font-label">
                <span>{s.domain}</span>
                <span className="text-foreground-300">&middot;</span>
                <span>{s.type}</span>
              </div>
            </div>
          </div>
        ))}

        {upcomingSessions.length === 0 && (
          <div className="text-center py-8">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-background-200">
              <i className="ri-calendar-check-line text-foreground-400 text-xl" />
            </div>
            <p className="text-sm text-foreground-500 font-label">{t('dashboard.noSessionsToday')}</p>
          </div>
        )}
      </div>
    </div>
  );
}